<app-alert-sucesso [alertSucesso]="showAlertSucesso" alertSucessoMensagem="Clique em Sair para finalizar o processo"
  alertSucessoSubtitulo="Endereço alterado com Sucesso" (alertSucessoFechou)="eventoAlertSucesso($event)">
</app-alert-sucesso>

@if (alertAlterarEndereco === true) {
<div class="body-alert">
  <div class="div-alert text-center">

    <p class="titulo-alert text-start">Alterar Endereço</p>
    <p class="subtitulo-alert text-start">Verifique o endereço que quer alterar e selecione o campo abaixo</p>

    <table class="table table-hover border-bottom mt-4" aria-describedby="tabela com endereco">
      <thead>
        <tr>
          <th class="coluna-cnpj" scope="col">CNPJ</th>
          <th scope="col">ENDEREÇO DE FATURAMENTO</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-nowrap"> {{ $safeNavigationMigration(enderecoSelecionado?.empresa.cnpj) | cnpj }} </td>
          <td> {{ enderecoSelecionado.enderecoFaturamento.descricaoLogradouro | camelCase }},
            {{ enderecoSelecionado.enderecoFaturamento.codigoNumero }}
            - {{ enderecoSelecionado.enderecoFaturamento.codigoBairro | camelCase }}
            - {{ enderecoSelecionado.enderecoFaturamento.codigoCidade | camelCase }}
            - {{ enderecoSelecionado.enderecoFaturamento.codigoEstado | camelCase }}
            - {{ enderecoSelecionado.enderecoFaturamento.codigoCep | camelCase }} </td>
        </tr>
      </tbody>
    </table>

    <P class="texto-titulo text-start"> ENDEREÇO PARA FATURAMENTO</P>

    <select class="form-control" (change)="onEnderecoSelecionado()" [(ngModel)]="newEnderecoSelecionado" [ngClass]="{ 'is-invalid': enderecoSelecionadoError }">
      <option value="">Selecionar endereço</option>
      @for (e of enderecosFaturamento; track e.idEndereco) {
        <option [value]="e.idEndereco">
          {{ e.descricaoLogradouro | camelCase }}, {{ e.codigoNumero }} -
          {{ e.codigoBairro | camelCase }}-
          {{ e.codigoCidade | camelCase }}  - {{ e.codigoEstado }}-
          {{ e.codigoCep | camelCase }}
        </option>
      }
    </select>
    <field-error [isError]="enderecoSelecionadoError" message="Selecione um endereço válido"></field-error>
    <button type="button" class="botao-outline me-2" (click)="cancelarAlterarEndereco()">CANCELAR</button>
    <button class="botao mt-3 mb-3" (click)=" onSubmit() ">ALTERAR</button>
  </div>
</div>
}
